import type { ScheduleTab, WorkspaceSchedule } from '@/features/reports'

/**
 * The tabs of a schedule that serve one partition. A tab map keyed by partition may omit the
 * `partition_name` on its entries, so the key stands in for it (v3 `getPartitionColumns:267-276`).
 */
export function partitionTabs(
  schedule: WorkspaceSchedule | null | undefined,
  partitionName: string,
): ScheduleTab[] {
  return Object.entries(schedule?.additional_info?.tabs ?? {})
    .flatMap(([key, entry]): ScheduleTab[] =>
      typeof entry === 'object' && entry !== null
        ? [{ ...entry, partition_name: entry.partition_name ?? key }]
        : [],
    )
    .filter((entry) => entry.partition_name === partitionName)
}
